import { useState } from "react";
import { toast } from "sonner";
import { Printer, CaretDown } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { printDocumentPart } from "@/lib/printPdf";

export const PRINT_PARTS = [
  { part: "letter", label: "Nur Schreiben" },
  { part: "attachments", label: "Nur Anlagen" },
  { part: "all", label: "Alles zusammen (Schreiben + Anlagen)" },
];

export function usePrintPart(documentId) {
  const [busy, setBusy] = useState(null);
  const run = async (part) => {
    setBusy(part);
    try { await printDocumentPart(documentId, part); }
    catch (e) { toast.error(e?.message || "Drucken fehlgeschlagen"); }
    finally { setBusy(null); }
  };
  return { busy, run };
}

// Drucken-Menü am Dokument: Schreiben / Anlagen / alles
export default function PrintPartsMenu({ documentId, attachmentCount = 0, testId = "print-parts" }) {
  const { busy, run } = usePrintPart(documentId);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={!!busy} className="gap-1" data-testid={`${testId}-btn`}>
          <Printer size={14} /> {busy ? "Bereite vor…" : "Drucken"} <CaretDown size={12} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {PRINT_PARTS.map((p) => (
          <DropdownMenuItem key={p.part} disabled={p.part !== "letter" && !attachmentCount}
            onSelect={() => run(p.part)} data-testid={`${testId}-${p.part}`}>
            {p.label}{p.part === "attachments" && attachmentCount ? ` (${attachmentCount})` : ""}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
